import { Component, Element, Fragment, Prop, h } from '@stencil/core';
import state from '../../store';
import { Category, CustomerCategory, CustomerSubCategory, Product, Service } from '../../types';
import { getProductPrice } from '../../utils/calc';
import { scrollToTop } from '../../utils/scroll';
import { isProduct } from '../../utils/types';

@Component({
  tag: 'hemfixarna-box',
  shadow: false,
})
export class HemfixarnaBox {
  @Prop() post: Category | Product | Service;
  @Prop() category: CustomerCategory | CustomerSubCategory | Product;
  @Prop() icon: string;
  @Prop() postTitle: string;
  @Element() private el: HTMLElement;

  setTaxonomy(taxonomy: Category | Service | Product) {
    if (taxonomy) {
      if ((taxonomy as Category)?.taxonomy === 'service_cat') {
        state.selectedCategory = taxonomy as Category;
        state.step = 2;
      } else if ((taxonomy as Service)?.post_type === 'service') {
        state.selectedService = taxonomy as Service;
        state.step = 3;
      } else if ((taxonomy as Product)?.post_type === 'ikea_product') {
        state.selectedProduct = taxonomy as Product;
        state.step = 4;
      }
      const el = this.el.closest('.hemfixarna_content');
      scrollToTop(el);
    }
  }

  setProduct() {
    state.selectedProduct = this.category as Product;
    state.step = 4;
    state.selectedCustomerCategory = null;
    const el = this.el.closest('.hemfixarna_content');
    scrollToTop(el);
  }

  render() {
    return this.category ? (
      <Fragment>
        {isProduct(this.category) ? (
          <li onClick={() => this.setProduct()}>
            <img class="hemfixarna_logo" height={82} src={this.category.icon as string} alt={this.category.post_name} />
            <div>
              <p>{this.category.title}</p>
              {!this.category.invoice ? <p class="price">Från {getProductPrice(this.category)}kr</p> : null}
            </div>
          </li>
        ) : (
          <li onClick={() => (state.selectedCustomerCategory = this.category as CustomerCategory)}>
            <img class="hemfixarna_logo" height={82} src={this.category.icon} alt={this.category.name} />
            <div>
              <p>{this.category.name}</p>
            </div>
          </li>
        )}
      </Fragment>
    ) : (
      <li onClick={() => this.setTaxonomy(this.post)}>
        {this.post.icon && <img class="hemfixarna_logo" height={82} src={this.icon} alt={this.postTitle} />}
        <div>
          <p>{this.postTitle}</p>
          {state.step === 3 && <p class="price">Från {getProductPrice(this.post as Product)}kr</p>}
        </div>
      </li>
    );
  }
}
